module.exports = __webpack_public_path__ + "img/icon-deposit.e9563cba.png";